import { FC, useEffect, useState } from 'react';
import Button from '../../../components/Button/Button';
import LoadingSpinner from '../../../components/Button/LoadingSpinner/LoadingSpinner';
import Header from '../../../components/Header/Header';
import { showToast } from '../../../components/Toast/Toast';
import { ToastTypes } from '../../../components/Toast/Toast.types';
import Tooltip from '../../../components/Tooltip/Tooltip';
import { useGlobalFreezes } from '../../../services/freeze/freeze.service';
import styles from './GlobalFreeze.module.css';
import GlobalFreezeCard from './GlobalFreezeCard/GlobalFreezeCard';
import GlobalFreezeForm from './GlobalFreezeForm/GlobalFreezeForm';
import { useTranslation } from 'react-i18next';

const GlobalFreeze: FC = () => {
  const { t } = useTranslation();
  const { data, isLoading, isError } = useGlobalFreezes(true);
  const [formIsOpen, setFormIsOpen] = useState(false);
  const [editFreezeId, setEditFreezeId] = useState<string | undefined>(undefined);

  const handleEditclick = (freezeId: string) => {
    setEditFreezeId(freezeId);
    setFormIsOpen(true);
  };

  const handleFormClose = () => {
    setFormIsOpen(false);
    setEditFreezeId(undefined);
  };

  const handleCreateClick = () => {
    setEditFreezeId(undefined);
    setFormIsOpen(true);
  };

  const freezes = data?.data || [];
  const renderFreezes = freezes.length ? (
    freezes.map((freeze) => <GlobalFreezeCard {...freeze} key={freeze.id} onEditClick={handleEditclick} />)
  ) : (
    <div className={styles.noFreezeMessage}>{t('toolkitFreeze.noGlobalFreezes')}</div>
  );

  useEffect(() => {
    if (isError)
      showToast({ toastType: ToastTypes.Error, label: t('error.fetchingGlobalFreezes'), id: 'globalFreezeError' });
  }, [isError, t]);

  if (isLoading) return <LoadingSpinner />;
  return (
    <>
      <Header title={t('toolkitFreeze.title')} />
      <div className={styles.page}>
        <p className={styles.description}>{t('toolkitFreeze.description')}</p>
        <div className={styles.titleRow}>
          <div className={styles.titleWithTooltip}>
            <h2 className={styles.title}>{t('toolkitFreeze.freezeDatesHeader')}</h2>
            <Tooltip content={t('toolkitFreeze.freezeDatesTooltip')} />
          </div>
          <Button onClick={handleCreateClick}>{t('toolkitFreeze.createNewButton')}</Button>
        </div>
        <div className={styles.freezes}>{renderFreezes}</div>
      </div>
      <GlobalFreezeForm isOpen={formIsOpen} handleClose={handleFormClose} freezeId={editFreezeId} />
    </>
  );
};

export default GlobalFreeze;
